/**
 * Guided tour for the Interactive Viewer's "Asbuilds" tab.
 *
 * Same step list as the In Progress tour (the underlying
 * ``InteractiveViewerPage`` is the same component); only the welcome copy
 * and the registered feature flag differ. See
 * ``../interactive-viewer/steps.ts`` for the shared definitions.
 */
import { registerTour } from '@/features/tours';
import { buildInteractiveViewerSteps } from '@/features/tours/interactive-viewer/steps';
import { FEATURE_FLAGS } from '@/features/featureFlags';

export const ASBUILDS_TOUR_ID = 'asbuilds.intro';

registerTour({
  id: ASBUILDS_TOUR_ID,
  name: 'Asbuilds',
  // v2: added unit-polygon + heat-map steps (area-tag layouts).
  // v3: heat map is now opt-in (off by default); button "turns it on".
  version: 3,
  featureFlagKey: FEATURE_FLAGS.ASBUILDS_VIEWER.id,
  steps: buildInteractiveViewerSteps({
    featureName: 'Asbuilds',
    welcomeBody:
      'This is the Asbuilds feature, where you can view as-built site ' +
      'photos at specific locations on each layout.',
  }),
});
